import { useTranslation } from 'react-i18next';
import LinkDrawer from '@/components/LinkDrawer';
import { useDeviceDimensions } from '@/hooks/useDeviceDimensions';
import { LinkModal } from '../LinkModal';

const CareForHeartConsentModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { t } = useTranslation();
  const { isDesktopDimensions } = useDeviceDimensions();
  const careForHeartConsentUrl = t('general.links.care-for-heart-consent');

  return isDesktopDimensions ? (
    <LinkModal
      open={open}
      onClose={onClose}
      src={careForHeartConsentUrl}
      title="Informed Consent"
    />
  ) : (
    <LinkDrawer
      url={careForHeartConsentUrl}
      title="Informed Consent"
      isOpen={open}
      handleClose={onClose}
    />
  );
};

export { CareForHeartConsentModal };
